import { lazy, Suspense } from "react";
import type { CalendarEvent } from "@worki/shared";
import {
  calendarFetchWindow,
  dateInputValue,
  type CalendarView,
} from "../../lib/calendarDates.js";
const CalendarView = lazy(() => import("./FullCalendarView.js"));
interface Props {
  view: CalendarView;
  date: Date;
  events: CalendarEvent[];
  locale: "he" | "en";
  onDateSelect: (date: Date) => void;
  onDateCreate?: (date: Date) => void;
  onEventOpen: (event: CalendarEvent) => void;
}
/** Load the interactive engine only in the browser and only on this route. */
export function CalendarSurface(props: Props) {
  const start = calendarFetchWindow(props.date, "month").from;
  const placeholder = (
    <div
      role="grid"
      aria-colcount={7}
      aria-rowcount={6}
      dir={props.locale === "he" ? "rtl" : "ltr"}
      className="grid grid-cols-7"
    >
      {Array.from({ length: 42 }, (_, index) => {
        const day = new Date(
          start.getFullYear(),
          start.getMonth(),
          start.getDate() + index,
        );
        const inMonth = day.getMonth() === props.date.getMonth();
        return (
          <div
            key={index}
            role="gridcell"
            data-date={inMonth ? dateInputValue(day) : undefined}
            aria-hidden={!inMonth || undefined}
            className="flex min-h-16 items-start justify-center border border-border p-2 text-sm text-muted-foreground"
          >
            {inMonth ? day.getDate() : null}
          </div>
        );
      })}
    </div>
  );
  if (typeof window === "undefined") return placeholder;
  return (
    <Suspense fallback={placeholder}>
      <CalendarView {...props} />
    </Suspense>
  );
}
